import { render, staticRenderFns } from "./AlertSm.vue?vue&type=template&id=f10b403c&scoped=true"
import script from "./AlertSm.vue?vue&type=script&lang=js"
export * from "./AlertSm.vue?vue&type=script&lang=js"
import style0 from "./AlertSm.vue?vue&type=style&index=0&id=f10b403c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10b403c",
  null
  
)

export default component.exports